import { OAuth2Service, OAuth2Config } from '@labb/dx-engine';

async function getPegaToken(
  baseUrl: string,
  clientId: string,
  clientSecret: string,
  identityToken: string,
  region?: string,
  locale?: string
) {
  const customTokenParameters: Record<string, string> = {
    identity_token: identityToken,
  };

  if (region && region !== '') {
    customTokenParameters.region = region;
  }
  if (locale && locale !== '') {
    customTokenParameters.locale = locale;
  }

  const config: OAuth2Config = {
    accessTokenUrl: `${baseUrl}/PRRestService/oauth2/v1/token`,
    clientId: clientId,
    clientSecret: clientSecret,
    customTokenParameters,
    grantType: 'custom-bearer',
    authType: 'custom',
  };
  return await OAuth2Service.getTokenCredentials(config);
}

export { getPegaToken };
